<template>
  <el-dialog
    title="发货单"
    :visible.sync="visible"
    width="900px"
    @close="$emit('update:show', false)"
    v-if="model"
  >
    <div class="flex-row-between">
      <div>
        <span class="number">{{ model.code_number }}</span>
        <br />
        <span class="text-info-12"
          >{{ model.user.name }} {{ formatTime(model.created_at) }}</span
        >
      </div>
      <span>
        <el-button
          v-if="model.status == 1"
          type="primary"
          size="small"
          plain
          @click="edit"
          >编辑</el-button
        >
        <el-button
          v-if="model.status == 1"
          type="danger"
          size="small"
          plain
          @click="del"
          >删除</el-button
        >
      </span>
    </div>
    <ul class="details mt-10">
      <li>
        <span class="title">发货方式：</span>
        <span>{{ model.supplier_id > 0 ? '供应商发货' : '仓库发货' }}</span>
      </li>
      <li v-if="model.supplier_id > 0">
        <span class="title">供应商：</span>
        <span>{{ model.supplier.name }}</span>
      </li>
      <li>
        <span class="title"
          >{{ model.category_id == 3 ? '发货时间' : '出库日期' }}：</span
        >
        <span>{{ formatTime(model.stock_out_date) }}</span>
      </li>
      <li>
        <span class="title">物流单号：</span>
        <span>{{ model.express_number }}</span>
      </li>
      <li>
        <span class="title">物流公司：</span>
        <span>{{ model.express_company }}</span>
      </li>
      <li>
        <span class="title">备注：</span>
        <span>{{ model.remark }}</span>
      </li>
      <li>
        <span class="title">产品明细：</span>
        <div style="flex: 1" v-if="model">
          <el-table v-if="!isMobile()" :data="model.items">
            <el-table-column label="对象" width="60px">
              <template slot-scope="scope">
                {{ scope.row.item.category == 1 ? '零件' : '设备' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="item.name"
              label="名称"
              min-width="250px"
            ></el-table-column>
            <el-table-column
              prop="item.part_number"
              label="件号"
              min-width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="item.machine_type"
              label="机型"
              min-width="120px"
              align="center"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="stockroom.name"
              label="仓库"
              width="80px"
              v-if="model.category_id == 1"
            >
              <template slot-scope="scope">
                <span :class="{ 'text-danger': scope.row.stockroom.id == 0 }">{{
                  scope.row.stockroom.id > 0
                    ? scope.row.stockroom.name
                    : '库存不足'
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="单价" width="80" align="center">
              <template slot-scope="scope">
                {{ scope.row.unit_price.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="item_number"
              label="数量"
              width="80"
              align="center"
            ></el-table-column>
          </el-table>
          <ul v-else class="list-style">
            <li v-for="item in model.items">
              <div>
                {{ item.item.name }}
                <span class="text-gray"
                  >[{{ item.item.part_number }}/
                  {{ item.item.machine_type }}]</span
                >
              </div>
              <div class="flex-row-between">
                <span> {{ item.unit_price.toFixed(2) }} </span>
                <span>x{{ item.item_number }}</span>
              </div>
              <div>
                <span>仓库：</span>
                <span :class="{ 'text-danger': item.stockroom.id == 0 }">{{
                  item.stockroom.id > 0 ? item.stockroom.name : '库存不足'
                }}</span>
              </div>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </el-dialog>
</template>

<script>
import { formatTime } from '@/util/index'
import { deleteStockOutBill } from '../service/getData'
import { isMobile } from '../util'

export default {
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      isMobile,
      formatTime,
      visible: this.show,
    }
  },
  methods: {
    edit() {
      this.$emit('edit', this.model)
      this.visible = false
    },
    del() {
      let that = this
      this.$confirm('是否确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        deleteStockOutBill(that.model.id).then((res) => {
          if (res.code == 0) {
            this.$emit('deleted', this.model)
            this.visible = false
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.number {
  font-size: 16px;
}
.details > li {
  padding: 8px 0;
  display: flex;
}

.details li .title {
  width: 80px;
}

.title {
  color: #888;
}
</style>